import config from '../config/config.json'

export default config
